import { render, staticRenderFns } from "./CardIntro.vue?vue&type=template&id=5326a35c&scoped=true"
import script from "./CardIntro.vue?vue&type=script&lang=js"
export * from "./CardIntro.vue?vue&type=script&lang=js"
import style0 from "./CardIntro.vue?vue&type=style&index=0&id=5326a35c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5326a35c",
  null
  
)

export default component.exports